// monitoring/* page translations
const monitoring = {
  home: {
    title: 'Giám sát toàn công ty',
    loading: 'Đang tải dữ liệu...',
    noFactories: 'Không có nhà máy nào được đăng ký',
    registerFactoryHint: 'Vui lòng đăng ký nhà máy trong menu Quản lý hệ thống',
    status: {
      total: 'Tổng số máy',
      running: 'Đang chạy',
      idle: 'Chờ',
      stopped: 'Dừng',
    },
  },
  enterprise: {
    v2: {
      targetModal: {
        title: 'Mục tiêu sản lượng ngày theo nhà máy',
        hint: 'Nhập mục tiêu ngày (số shot) cho từng nhà máy. Áp dụng mỗi ngày cho đến khi thay đổi; mục tiêu toàn công ty là tổng. Để trống để xóa mục tiêu.',
        factory: 'Nhà máy',
        today: 'Hôm nay',
        target: 'Mục tiêu ngày',
        placeholder: 'Chưa đặt',
        unit: 'cái',
        total: 'Mục tiêu toàn công ty (tổng)',
        saving: 'Đang lưu...',
        invalid: 'Nhập số nguyên từ 1 trở lên',
        saveFailed: 'Không lưu được. Vui lòng thử lại',
        notDeployed: 'Máy chủ chưa triển khai chức năng mục tiêu theo nhà máy',
        forbidden: 'Bạn không có quyền sửa nhà máy',
        noPermission: 'Cần quyền sửa nhà máy (factory.update) để thay đổi mục tiêu',
      },
      breadcrumbRoot: 'Toàn công ty',
      pageLabel: 'Bảng điều khiển tổng hợp',
      refresh: 'Làm mới',
      retry: 'Thử lại',
      loading: 'Đang tải...',
      noData: 'Không có dữ liệu',
      loadFailed: 'Không tải được dữ liệu bảng điều khiển',
      unitEa: 'cái',
      unitMachine: 'máy',
      estimated: 'ước tính',
      level: {
        good: 'Bình thường',
        warn: 'Cảnh báo',
        bad: 'Nguy hiểm',
      },
      kpi: {
        oee: 'OEE tổng hợp',
        availability: 'Khả dụng',
        performance: 'Hiệu suất',
        quality: 'Tỷ lệ đạt',
        defectRate: 'Tỷ lệ lỗi',
        utilization: 'Tỷ lệ vận hành',
        production: 'Sản lượng ngày',
        energy: 'Năng lượng',
        oeeSub: 'Mục tiêu {target}% · {diff}%p',
        baseline: 'Chuẩn {v}',
        inRange: 'Trong phạm vi',
        defectSub: '{n} lỗi · chuẩn ≤{v}',
        defectEstimated: '100 − tỷ lệ đạt (ước tính)',
        utilizationSub: '{r} / {n} máy chạy',
        productionSub: '{p}% mục tiêu',
        noTarget: 'Chưa đặt mục tiêu',
        energySub: '{p}% so với hôm qua',
        today: 'Hôm nay',
      },
      chart: {
        productionTitle: 'Xu hướng sản lượng · vận hành',
        oeeTitle: 'Xu hướng thành phần OEE',
        days: '({n} ngày)',
        production: 'Sản lượng (EA)',
        rate: 'Vận hành (%)',
        oee: 'OEE',
        availability: 'Khả dụng',
        performance: 'Hiệu suất',
        quality: 'Chất lượng',
      },
      factory: {
        title: 'Tình trạng nhà máy',
        activeAlarms: '{n} cảnh báo chưa xử lý',
        rate: 'Vận hành',
        production: 'Sản lượng',
        equipment: 'Thiết bị',
        running: 'Chạy',
        stopped: 'Dừng',
        collect: {
          ok: 'Thu thập bình thường',
          partial: 'Dừng một phần',
          lost: 'Mất thu thập',
          none: 'Không có máy',
        },
      },
      alarm: {
        title: 'Toàn công ty',
        all: 'Xem tất cả',
        critical: 'Khẩn cấp',
        warning: 'Chú ý',
        info: 'Thông tin',
        empty: 'Không có cảnh báo gần đây',
      },
      target: {
        factoryGoal: '{a} / {g}',
        factoryNoTarget: 'Chưa đặt mục tiêu',
        companyOnlyNote: 'Chỉ có mục tiêu toàn công ty — đặt mục tiêu từng nhà máy bằng nút bánh răng',
        title: 'Đạt mục tiêu sản xuất (hôm nay)',
        ratio: 'Tỷ lệ đạt',
        goal: 'Mục tiêu',
        actual: 'Thực tế',
        remaining: 'Còn lại',
        eta: 'Thời gian dự kiến đạt',
        hm: '{h} giờ {m} phút',
        m: '{m} phút',
        done: 'Đã đạt',
        factoryNote: 'Thanh theo nhà máy: sản lượng nhà máy so với mục tiêu toàn công ty (chưa có mục tiêu theo nhà máy)',
      },
    },
    reports: {
      daily: 'Báo cáo ngày',
      weekly: 'Báo cáo tuần',
      monthly: 'Báo cáo tháng',
    },
    oee: {
      targetSetting: 'Cài đặt sản lượng mục tiêu',
    },
  },
  factory: {
    selectFactory: 'Chọn nhà máy',
    loadingData: 'Đang tải dữ liệu...',
    noFactories: 'Chưa có nhà máy nào được đăng ký',
    registerFactoryHint: 'Vui lòng đăng ký nhà máy trong menu Quản lý hệ thống',
    loadFailed: 'Không thể tải dữ liệu.',
    factoryListLoadFailed: 'Không thể tải danh sách nhà máy.',
    retry: 'Thử lại',
    refresh: 'Làm mới',
    breadcrumbRoot: 'Toàn công ty',
    overview: 'OVERVIEW',
    kpi: {
      activeRatio: 'Đang chạy',
      totalMachines: 'Số máy',
      running: 'Chạy',
      idle: 'Chờ',
      stopped: 'Dừng',
      pendingAlarms: 'Cảnh báo chưa xử lý',
      oee: 'OEE',
      dailyProduction: 'Sản lượng ngày',
      machineUnit: ' máy',
      caseUnit: '',
    },
    environment: {
      title: 'Môi trường',
      temperature: 'Nhiệt độ',
      tempUnit: '°C',
      humidity: 'Độ ẩm',
      energy: 'Năng lượng',
      noise: 'Tiếng ồn',
    },
    line: {
      title: 'Tình trạng theo line',
      production: 'Sản lượng',
      alarms: 'Cảnh báo',
      caseUnit: '',
      running: 'Chạy',
      idle: 'Chờ',
      stopped: 'Dừng',
      empty: 'Không có thông tin line',
    },
    machine: {
      title: 'Tình trạng theo máy',
      statusFilter: 'Trạng thái',
      lineFilter: 'Line',
      running: 'Chạy',
      idle: 'Chờ',
      stopped: 'Dừng',
      moldNumber: 'Số khuôn',
      shotCount: 'Số shot',
      cav: 'CAV', // 캐비티 수 — 현장 약어 그대로
      ct: 'C/T', // 사이클 타임 — 현장 약어 그대로
      alarmsTitle: '{n} cảnh báo đang hoạt động',
      loading: 'Đang tải máy...',
      empty: 'Không có máy để hiển thị',
    },
    alarm: {
      title: 'Cảnh báo thời gian thực',
      all: 'Tất cả',
      critical: 'Nguy hiểm',
      warning: 'Cảnh báo',
      noActiveAlarms: 'Không có cảnh báo đang hoạt động.',
    },
  },
  realtimeShot: {
    v2: {
      breadcrumbRoot: 'Toàn công ty',
      allFactories: 'Tất cả nhà máy',
      refresh: 'Làm mới',
      factory: 'Nhà máy',
      line: 'Dây chuyền',
      all: 'Tất cả',
      deviationOnly: 'Chỉ sai lệch',
      summary: 'Tổng {n} máy · sai lệch {d} máy',
      deviationTip: 'Sai lệch (ước tính): giá trị thay đổi ±5% trở lên so với shot trước — tính trên màn hình, chưa có API giới hạn',
      prevShot: 'Shot trước',
      noDeviation: 'Không có máy sai lệch',
      colEquipment: 'Máy ép',
      colUpdate: 'Cập nhật',
    },
    title: 'Trạng thái shot thời gian thực',
    subtitle: 'Trạng thái shot theo từng máy',
    update: 'Cập nhật',
    loading: 'Đang tải dữ liệu...',
    loadFailed: 'Tải dữ liệu thất bại.',
    retry: 'Thử lại',
    noData: 'Không có dữ liệu.',
    options: {
      highlight: 'Đánh dấu thay đổi',
      delta: 'Hiện chênh lệch',
      sortByUpdate: 'Sắp xếp theo cập nhật',
    },
    columns: {
      equipmentName: 'Máy',
      craftId: 'Sản phẩm',
      shotCount: 'Số shot',
      updateDateTime: 'Thời gian cập nhật',
      cycleTime: 'Chu kỳ',
      tmInjSpeed1: 'Tốc độ ép',
      tmInjPress1: 'Áp ép',
      tmInjPosi1: 'Vị trí ép',
      tmHoldSpeed1: 'Tốc độ giữ',
      tmHoldPress1: 'Áp giữ',
      tmChargePress1: 'Áp cấp',
      tmChargePosi1: 'Vị trí cấp',
      turnPosi: 'Vị trí kết thúc ép',
      cushion: 'Lượng đệm',
      tmTemp1Current: 'Nhiệt độ 1',
      tmTemp2Current: 'Nhiệt độ 2',
      tmTemp3Current: 'Nhiệt độ 3',
      tmTemp4Current: 'Nhiệt độ 4',
      tmTemp5Current: 'Nhiệt độ 5',
    },
  },
  alarmAnalysis: {
    title: 'Phân tích chi tiết cảnh báo',
    machinePrefix: 'Máy: {name}',
    alarmIdPrefix: 'ID cảnh báo: {id}',
    loading: 'Đang tải dữ liệu cảnh báo...',
    loadFailed: 'Tải dữ liệu cảnh báo thất bại.',
    loadFailedTitle: 'Tải dữ liệu thất bại',
    retry: 'Thử lại',
    info: {
      title: 'Thông tin cảnh báo',
      alarmId: 'ID cảnh báo',
      machine: 'Máy',
      occurredAt: 'Thời gian xảy ra',
      duration: 'Thời lượng',
      severity: 'Mức độ',
      status: 'Trạng thái',
    },
    message: {
      title: 'Nội dung cảnh báo',
      description: 'Cần API để hiển thị chi tiết cảnh báo.',
      note: 'Trang này được thiết lập để nhận ID cảnh báo và thông tin máy từ tham số URL.',
    },
    cause: {
      title: 'Phân tích nguyên nhân',
      placeholder: 'Thông tin phân tích nguyên nhân cảnh báo sẽ hiển thị tại đây.',
    },
    action: {
      title: 'Hành động khuyến nghị',
      placeholder: 'Hành động khuyến nghị sẽ hiển thị tại đây.',
    },
    apiNotice: {
      label: 'Cần tích hợp API:',
      description: 'Cần endpoint API backend để hiển thị chi tiết cảnh báo.',
      endpoint: 'Endpoint dự kiến:',
    },
  },
  machine: {
    breadcrumbRoot: 'Toàn công ty',
    breadcrumbMonitoring: 'Giám sát',
    selectMonitoringPage: 'Chọn màn hình giám sát',
    refresh: 'Làm mới',
    selectFactory: 'Chọn nhà máy',
    factoryPage: 'Mở tình trạng nhà máy',
    factoryMachineCount: '{n} máy',
    selectMachine: 'Chọn thiết bị',
    loading: 'Đang tải...',
    loadingData: 'Đang tải dữ liệu...',
    noEquipment: 'Không có thiết bị nào được đăng ký',
    registerEquipmentHint: 'Vui lòng đăng ký thiết bị trong menu Quản lý hệ thống',
    tabs: {
      overviewNew: 'Tổng quan (mới)',
      process: 'Quy trình',
      dashboard: 'Bảng điều khiển',
      quality: 'Chất lượng · Sản xuất',
      dataLog: 'Dữ liệu · Nhật ký',
    },
    tabPlaceholder: '{tab} (sẽ bổ sung sau)',
    chartLabel: {
      shotNumber: 'Số shot',
      tempC: 'Nhiệt độ(°C)',
      pressureMpa: 'Áp suất(MPa)',
      powerKw: 'Công suất(kW)',
      speedMms: 'Tốc độ(mm/s)',
      positionMm: 'Vị trí(mm)',
    },
    legendName: {
      injectionPressure: 'Áp ép',
      holding: 'Giữ áp',
      meteringPressure: 'Áp cấp',
      backPressure: 'Áp ngược',
      holdingPressure: 'Áp giữ',
      injectionPressure2: 'Áp ép',
      cycleTime: 'Thời gian chu kỳ',
      injectionTime: 'Thời gian ép',
      holdingTime: 'Thời gian giữ',
      meteringTime: 'Thời gian cấp',
      coolingTime: 'Thời gian làm mát',
      pressureKw: 'Công suất(kW)',
      speed: 'Tốc độ',
      position: 'Vị trí',
      occurrence: 'Số lần xảy ra',
      cumulativeRatio: 'Tỷ lệ tích lũy (%)',
      alarmCount: 'Số cảnh báo',
      ucl: 'UCL',
      cl: 'CL',
      lcl: 'LCL',
      measured: 'Giá trị đo',
      rangeValue: 'Phạm vi',
      upper: 'Trên',
      lower: 'Dưới',
      motorStatus: 'Trạng thái motor',
    },
    common: {
      noData: 'Không có dữ liệu',
      loading: 'Đang tải...',
      dataLoadFailed: 'Tải dữ liệu thất bại.',
      productionWidgetWip: 'Widget sản xuất đang chuẩn bị',
      configError: 'Lỗi cấu hình',
      widgetContent: 'Nội dung widget',
      occurredPrefix: 'Xảy ra: ',
      occurring: 'Đang xảy ra',
      resolved: 'Đã giải quyết',
      alarmHistoryEmpty: 'Không có lịch sử cảnh báo',
    },
    widget: {
      titleSuffix: {
        temperature: 'Nhiệt độ(°C)',
        pressure: 'Áp suất(MPa)',
        energy: 'Năng lượng(kW)',
      },
      modal: {
        title: 'Thêm widget bảng điều khiển',
        size1x1: '1×1 (Mặc định)',
        size2x1: '2×1 (Ngang)',
        size1x2: '1×2 (Dọc)',
        size2x2: '2×2 (Lớn)',
        back: 'Quay lại',
      },
      dashboardNew: {
        myDashboard: 'Dashboard của tôi',
        subtitle: '{n} widget',
        autoRefresh: 'Tự động làm mới {v}',
        addEdit: 'Thêm widget · Chỉnh sửa',
        editMode: 'Chế độ chỉnh sửa',
        editHint: 'Kéo widget để sắp xếp · bấm nhãn kích thước để đổi cỡ · X để xóa',
        resetLayout: 'Đặt lại bố cục',
        resetConfirm: 'Xóa tất cả widget đã đặt?',
        doneEdit: 'Hoàn tất',
        addWidget: 'Thêm widget',
        remove: 'Xóa',
        sizeBadgeHint: 'Bấm để chuyển sang kích thước tiếp theo vừa chỗ',
        searchPlaceholder: 'Tìm widget (nhiệt độ, áp suất, cảnh báo…)',
        cat: { all: 'Tất cả', process: 'Quy trình', equipment: 'Thiết bị', quality: 'Chất lượng', alarm: 'Cảnh báo', user: 'Tùy chỉnh' },
        catHint: 'Bấm chip để chỉ hiện danh mục đó',
        note: { process: 'Quy trình', equipment: 'Thiết bị', quality: 'Chất lượng', alarm: 'Cảnh báo', user: 'Tùy chỉnh' },
        placed: 'Đã đặt',
        add: 'Thêm',
        placedCount: 'Widget đã đặt {n} / {total}',
        close: 'Đóng',
        noResults: 'Không tìm thấy widget',
        sizeTitle: 'Chọn kích thước widget',
        sizeHint: 'Chọn số ô lưới. Sau khi đặt có thể đổi bằng nhãn kích thước.',
        sizeDesc: { '1x1': '1–2 chỉ số chính', '2x1': 'Bảng và biểu đồ xu hướng (khuyến nghị)', '1x2': 'Danh sách · lịch sử', '2x2': 'Biểu đồ tổng hợp · chi tiết' },
        addWithSize: 'Thêm cỡ {size}',
        noFit: 'Không còn chỗ trống cho kích thước này',
      },
      types: {
        temperature: { name: 'Nhiệt độ', desc: 'Trạng thái và xu hướng nhiệt độ Zone' },
        pressure: { name: 'Áp suất', desc: 'Giám sát áp ép/giữ' },
        energy: { name: 'Năng lượng', desc: 'Tiêu thụ và hiệu suất điện' },
        basicInfo: { name: 'Thông tin cơ bản', desc: 'Sản phẩm, số shot, chu kỳ, khoang' },
        alarmHistory: { name: 'Lịch sử cảnh báo', desc: 'Lịch sử cảnh báo gần đây' },
        injectionInfo: { name: 'Thông tin ép', desc: 'Cài đặt và tham số ép' },
        custom: { name: 'Module tùy chỉnh', desc: 'Thêm widget tùy chỉnh' },
        cycle: { name: 'Chu kỳ', desc: 'Thời gian chu kỳ TB/min/max và các shot gần đây' },
        spc: { name: 'SPC', desc: 'Biểu đồ X-bar · phát hiện vượt UCL/LCL' },
        quality: { name: 'Đạt/Lỗi', desc: 'Tỷ lệ đạt hôm nay · số đạt · số lỗi' },
      },
      body: {
        loading: 'Đang tải...',
        loadFailed: 'Không tải được',
        noData: 'Không có dữ liệu',
        warning: 'Chú ý',
        set: 'Cài đặt',
        latestShot: 'shot mới nhất',
        avgPower: 'TB {n} shot gần nhất',
        power: 'Công suất',
        today: 'hôm nay',
        sampleNote: '{n} shot gần nhất',
        efficiency: 'Hiệu suất',
        shot: 'shot',
        legendInjection: 'Phun',
        legendHolding: 'Giữ áp',
        avg: 'TB',
        min: 'Min',
        max: 'Max',
        cycleTime: 'Thời gian chu kỳ',
        measured: 'Đo',
        out: 'Vượt',
        spcNote: 'Biểu đồ X-bar · {p}',
        goodRate: 'Tỷ lệ đạt',
        good: 'Đạt',
        defect: 'Lỗi',
        defectRate: 'Tỷ lệ lỗi',
      },
      builder: {
        title: 'Tạo module tùy chỉnh',
        widgetSize: 'Kích thước widget',
        widgetTitle: 'Tiêu đề widget',
        widgetTitlePlaceholder: 'Nhập tiêu đề widget',
        chartType: 'Loại biểu đồ',
        chartLine: 'Biểu đồ đường',
        chartBar: 'Biểu đồ cột',
        chartArea: 'Biểu đồ vùng',
        xAxis: 'Dữ liệu trục X',
        yAxis: 'Dữ liệu trục Y',
        xShotNumber: 'Số shot',
        xTime: 'Thời gian',
        yPressure: 'Áp suất (MPa)',
        yTemperature: 'Nhiệt độ (℃)',
        ySpeed: 'Tốc độ (mm/s)',
        yPosition: 'Vị trí (mm)',
        preview: 'Xem trước',
        summary: 'Tóm tắt',
        summarySize: 'Kích thước',
        summaryTitle: 'Tiêu đề',
        summaryTitleEmpty: '(trống)',
        summaryChart: 'Loại biểu đồ',
        summaryX: 'Trục X',
        summaryY: 'Trục Y',
        cancel: 'Hủy',
        complete: 'Hoàn tất',
      },
    },
    overview: {
      basicInfo: 'Thông tin cơ bản',
      injection: 'Ép',
      holding: 'Giữ áp',
      metering: 'Cấp liệu',
      mold: 'Khuôn',
      ejector: 'Đẩy',
      heater: 'Nhiệt độ heater',
      noData: 'Không có dữ liệu',
      labels: {
        productName: 'Tên sản phẩm',
        shotCount: 'Số shot',
        cycleTime: 'Thời gian chu kỳ',
        cavityCount: 'Số khoang',
        unitCount: 'lần',
        unitPiece: 'cái',
        maxPressure: 'Áp ép tối đa',
        startPosition: 'Vị trí bắt đầu ép',
        switchPosition: 'Vị trí chuyển ép',
        injectionTime: 'Thời gian ép',
        injectionSpeed: 'Tốc độ ép',
        suckbackTime: 'Thời gian hút lùi',
        suckbackSpeed: 'Tốc độ hút lùi',
        switchMode: 'Chế độ chuyển giữ',
        switchInput: 'Đầu vào chuyển giữ',
        pressure1: 'Áp giữ bậc 1',
        pressure2: 'Áp giữ bậc 2',
        time1: 'Thời gian giữ 1',
        time2: 'Thời gian giữ 2',
        meteringPosition: 'Vị trí cấp',
        meteringSpeed: 'Tốc độ cấp',
        meteringPressure: 'Áp cấp',
        meteringTime: 'Thời gian cấp',
        moldThickness: 'Độ dày khuôn',
        openPosition: 'Vị trí mở khuôn',
        closePosition: 'Vị trí đóng khuôn',
        openTime: 'Thời gian mở',
        closeTime: 'Thời gian đóng',
        moldTemp1: 'Nhiệt độ khuôn 1',
        moldTemp2: 'Nhiệt độ khuôn 2',
        forwardPosition: 'Vị trí tiến',
        backwardPosition: 'Vị trí lùi',
        forwardSpeed: 'Tốc độ tiến',
        backwardSpeed: 'Tốc độ lùi',
        zoneTemp: 'Nhiệt độ Zone {n}',
        nozzleTemp: 'Nhiệt độ vòi',
      },
    },
    spc: {
      measurementItem: 'Tham số',
      params: {
        cycleTime: 'Thời gian chu kỳ',
        injectionPressure: 'Áp ép',
        injectionSpeed: 'Tốc độ ép',
        moldTemperature: 'Nhiệt độ khuôn',
        cushion: 'Đệm',
      },
      loading: 'Đang tải dữ liệu SPC...',
      xbarChart: 'Biểu đồ X̄ (X-bar)',
      rChart: 'Biểu đồ R',
      stats: 'Thống kê',
      processCapability: 'Năng lực quá trình',
      basicStats: 'Thống kê cơ bản',
      defectRate: 'Tỷ lệ lỗi',
      sampleCount: 'Số mẫu',
      mean: 'Trung bình',
      stdDev: 'Độ lệch chuẩn',
      min: 'Min',
      max: 'Max',
      range: 'Phạm vi',
      anomalyDetection: 'Phát hiện bất thường',
      anomalyTime: 'Thời gian',
      anomalyValue: 'Giá trị',
      anomalyType: 'Loại',
      noAnomaly: 'Không phát hiện bất thường',
    },
    passFail: {
      back: 'Quay lại',
    },
    inspectionPhotos: {
      subTabSpc: 'Quản lý quy trình (SPC)',
      subTabJudge: 'Kiểm tra quy trình',
      subTabProduction: 'Sản xuất',
      subTabPhotos: 'Kiểm tra hình ảnh',
      subTabFusion: 'Kiểm tra hợp nhất',
      subTabSync: 'Đồng bộ shot',
      comingSoon: 'Sắp ra mắt',
      period: 'Kỳ',
      good: 'Đạt',
      none: 'Chưa đánh giá',
      warn: 'Chú ý',
      bad: 'Lỗi',
      upload: 'Tải ảnh lên',
      uploadNotice: 'Ảnh đã tải chỉ được giữ dưới dạng xem trước trên màn hình này (chưa kết nối lưu trữ máy chủ)',
      front: 'Mặt trước',
      topView: 'Trên',
      side: 'Mặt bên',
      photoPlaceholder: 'Ảnh kiểm tra',
      empty: 'Không có shot để hiển thị',
      prev: 'Trước',
      next: 'Sau',
    },
    visionInspection: {
      kpi: {
        inspected: 'Đã kiểm tra',
        ok: 'Đạt',
        ng: 'Lỗi',
        ngRate: 'Tỷ lệ lỗi',
        uninspected: 'Chưa kiểm tra',
      },
      typeDistribution: 'Lỗi theo loại',
      ngTotal: '{n} lỗi',
      typeFilterHint: 'Nhấp để chỉ xem loại này',
      types: {
        FLASH: 'Bavia',
        WELDLINE: 'Đường hàn',
        SHORT: 'Thiếu nhựa',
        SINK: 'Lõm co',
        UNKNOWN: 'Khác',
      },
      date: 'Ngày',
      verdict: 'Kết quả',
      defectType: 'Loại',
      verdicts: {
        all: 'Tất cả',
        ok: 'Đạt',
        ng: 'Lỗi',
      },
      resultCount: '{n} kết quả',
      empty: 'Không có kết quả kiểm tra hình ảnh cho ngày này',
      emptyFiltered: 'Không có kết quả phù hợp',
      noImage: 'Không có ảnh',
      detailTitle: 'Kiểm tra hình ảnh · Shot #{n}',
      close: 'Đóng',
      unjudged: 'Chưa đánh giá',
      field: {
        verdict: 'Kết quả hình ảnh',
        defectType: 'Loại lỗi',
        shotTime: 'Thời điểm shot',
        mold: 'Khuôn',
        processResult: 'Kiểm tra quy trình',
        imageFile: 'Tệp ảnh',
        shotUuid: 'UUID shot',
        sync: 'Đồng bộ shot',
      },
      processNote: 'Kết quả kiểm tra quy trình là đánh giá của AI quy trình cho cùng shot, chỉ để tham khảo. Xem Kiểm tra hợp nhất để biết kết quả cuối cùng.',
      prev: 'Trước',
      next: 'Sau',
    },
    shotSync: {
      source: { label: 'Nguồn dữ liệu', processDemo: 'Quy trình: demo', processReal: 'Quy trình: thu thập', imageDemo: 'Ảnh: camera demo', imageReal: 'Ảnh: IV4 thực', verdictDemo: 'Đánh giá: demo', liveLast: 'IV4 hiện trường nhận lần cuối {t} ({ago})', liveNone: 'Chưa nhận ảnh IV4 hiện trường', liveHint: 'Ở chế độ camera demo, ảnh IV4 hiện trường vẫn được thu thập. Khi nhận ổn định có thể chuyển sang chế độ IV4' },
      ago: { min: '{n} phút trước', hour: '{n} giờ trước' },
      engine: { on: 'Engine đồng bộ đang chạy', off: 'Engine đồng bộ tắt', lastRun: 'Lần chạy cuối {t}' },
      mode: { TIME_WINDOW: 'Cửa sổ thời gian', SEQUENCE: 'Theo số thứ tự' },
      kpi: { images: 'Ảnh đã xác nhận', pairRate: 'Tỷ lệ ghép', confidence: 'Độ tin cậy TB', unmatched: 'Không ghép', clock: 'Bù đồng hồ camera', lag: 'Trễ shot→chụp' },
      kpiHint: { clock: 'Đồng hồ camera chậm hơn máy chủ bao nhiêu. Ước tính mỗi lần chạy và áp dụng cho thời điểm ảnh', lag: 'Thời gian từ khi ép đến khi chụp. Chỉ cập nhật khi đủ căn cứ' },
      unit: { sec: '{v} giây' },
      timeline: { title: 'Đồng bộ thời gian thực (3 phút)', sub: 'Trễ L {lag} giây · dung sai ±{tol} giây', shots: 'Shot', images: 'Ảnh', pending: 'Chờ xác nhận', empty: 'Không có dữ liệu trong 3 phút gần nhất', off: 'Trạm đang tắt, đồng bộ thời gian thực tạm dừng' },
      legend: { shot: 'Shot đã ghép', shotEmpty: 'Shot chưa có ảnh', match: 'Khớp', check: 'Cần kiểm tra', none: 'Không ghép', pending: 'Chờ xác nhận', window: 'Cửa sổ (shot + L ± τ)' },
      trend: { title: 'Xu hướng 10 phút (3 giờ)', sub: 'Ảnh đã xác nhận theo trạng thái', empty: 'Không có dữ liệu xu hướng', lagRange: 'Trễ L {v} giây', clockRange: 'Bù đồng hồ {v} giây' },
      date: 'Ngày', status: 'Trạng thái',
      filters: { all: 'Tất cả', match: 'Khớp', check: 'Cần kiểm tra', unmatched: 'Không ghép' },
      statuses: { MATCH: 'Khớp', CHECK: 'Cần kiểm tra', MISMATCH: 'Không khớp', IMAGE_ONLY: 'Chỉ ảnh', SHOT_ONLY: 'Chỉ shot', PENDING: 'Chờ xác nhận' },
      reasonsLabel: 'Lý do không ghép:',
      reasons: { DUPLICATE: 'Chụp lặp', OUT_OF_WINDOW: 'Ngoài cửa sổ', NO_SHOT: 'Máy dừng', SHOT_TAKEN: 'Shot đã được ghép', LOW_CONFIDENCE: 'Độ tin cậy thấp', NO_IMAGE: 'Bỏ sót ảnh' },
      resultCount: '{n} mục',
      empty: 'Không có kết quả cho điều kiện đã chọn',
      col: { status: 'Trạng thái', shot: 'Shot', shotTime: 'Thời điểm shot', image: 'Ảnh', captured: 'Giờ camera → đã bù', residual: 'Sai lệch', confidence: 'Độ tin cậy', verdict: 'Đánh giá' },
      verdicts: { ok: 'Đạt', ng: 'Lỗi' },
      demoTag: 'Demo',
      prev: 'Trước', next: 'Sau', close: 'Đóng',
      note: 'Sai lệch = thời điểm chụp đã bù − (thời điểm shot + trễ L), càng gần 0 càng tốt. Chỉ cặp Khớp/Cần kiểm tra được dùng cho Kiểm tra thị giác và Hợp nhất; ảnh không ghép được lưu kèm lý do.',
      detail: { titleShot: 'Chi tiết đồng bộ shot #{n}', titleImage: 'Ảnh không ghép', reason: 'Lý do', captured: 'Giờ camera (tên tệp)', saved: 'Giờ lưu trên PC thị giác', note: 'Đồng hồ camera IV4 chậm hơn máy chủ khoảng 3 phút. Engine tự bù dựa trên chênh lệch giữa giờ lưu trên PC và giờ trong tên tệp rồi mới ghép với shot.' },
      noStation: { title: 'Máy này chưa có trạm camera thị giác', desc: 'Khi lắp camera và đăng ký trạm đồng bộ, engine sẽ tự ghép shot với ảnh và liên kết với Kiểm tra thị giác, Hợp nhất.', shots: 'Hôm nay {n} shot' },
      sourceNote: 'Nguồn dữ liệu — {items}',
      sourceItems: { process: 'quy trình demo', camera: 'ảnh camera demo', verdict: 'đánh giá demo' },
    },
    fusionInspection: {
      formulaTitle: 'Công thức hợp nhất',
      formulaRule: 'α + β = 1, lỗi nếu S_fusion ≥ θ',
      legendVision: 'S_vision · xác suất lỗi hình ảnh (0–1)',
      legendProcess: 'S_process · điểm bất thường quy trình (0–1)',
      legendWeights: 'α·β·θ · trọng số theo loại lỗi (bảng)',
      weightsTitle: 'Bảng trọng số theo loại lỗi',
      planWeights: 'giá trị ban đầu',
      planWeightsNote: 'Trọng số hiện tại là giá trị ban đầu trong kế hoạch dự án. Khi có từ 200 nhãn lỗi đã xác minh, α được tìm theo từng loại với bước 0,05 và thay bằng giá trị có F1 cao nhất.',
      noWeights: 'Không có thông tin trọng số',
      colType: 'Loại',
      colSplit: 'Hình ảnh : Quy trình',
      vision: 'Hình ảnh',
      process: 'Quy trình',
      fusion: 'Hợp nhất',
      kpi: {
        decided: 'Shot đã hợp nhất',
        processRate: 'Tỷ lệ lỗi quy trình',
        visionRate: 'Tỷ lệ lỗi hình ảnh',
        fusionRate: 'Tỷ lệ lỗi cuối cùng',
        rescued: 'Bắt mẫu mơ hồ',
        suppressed: 'Bỏ cảnh báo chỉ quy trình',
      },
      kpiHint: {
        rescued: 'Hình ảnh đánh giá đạt nhưng có bất thường quy trình nên hợp nhất đánh giá lỗi (nhấp để lọc)',
        suppressed: 'Chỉ quy trình bất thường, ảnh sạch nên hợp nhất đánh giá đạt (nhấp để lọc)',
      },
      countN: '{n}',
      matrixTitle: 'Bảng đối chiếu Quy trình × Hình ảnh',
      matrixSub: 'Nhấp vào ô để lọc danh sách',
      visionOk: 'Hình ảnh đạt',
      visionNg: 'Hình ảnh lỗi',
      processOk: 'Quy trình đạt',
      processNg: 'Quy trình lỗi',
      fusedNg: 'lỗi hợp nhất {n}',
      finalTypeTitle: 'Loại lỗi hợp nhất',
      processTypeNote: 'Do quy trình = ảnh không thấy loại lỗi nhưng hợp nhất đánh giá lỗi do bất thường quy trình',
      date: 'Ngày',
      finalVerdict: 'Kết quả cuối',
      all: 'Tất cả',
      ok: 'Đạt',
      ng: 'Lỗi',
      caseLabel: 'Trường hợp',
      cases: {
        all: 'Tất cả',
        disagree: 'Không khớp',
        changed: 'Hợp nhất thay đổi',
        rescued: 'Bắt mẫu mơ hồ',
        suppressed: 'Bỏ cảnh báo chỉ quy trình',
      },
      cells: {
        POK_VOK: 'Quy trình đạt · Hình ảnh đạt',
        POK_VNG: 'Quy trình đạt · Hình ảnh lỗi',
        PNG_VOK: 'Quy trình lỗi · Hình ảnh đạt',
        PNG_VNG: 'Quy trình lỗi · Hình ảnh lỗi',
      },
      empty: 'Không có kết quả hợp nhất cho ngày này. Chỉ đánh giá shot có cả kết quả quy trình và hình ảnh.',
      emptyFiltered: 'Không có kết quả phù hợp',
      colTime: 'Thời điểm',
      colShot: 'Shot',
      colWeight: 'α / β',
      colFusion: 'Điểm hợp nhất (│=θ)',
      colCase: 'Trường hợp',
      decisionCase: {
        BOTH_NG: 'Cả hai lỗi',
        BOTH_OK: 'Cả hai đạt',
        BOTH_OK_FUSED_NG: 'Cả hai đạt → lỗi',
        VISION_ONLY_NG_FUSED_NG: 'Chỉ hình ảnh → lỗi',
        VISION_ONLY_NG_FUSED_OK: 'Chỉ hình ảnh → đạt',
        PROCESS_ONLY_NG_FUSED_NG: 'Chỉ quy trình → lỗi',
        PROCESS_ONLY_NG_FUSED_OK: 'Chỉ quy trình → đạt',
        NONE: '—',
      },
      verdictScoreNote: '{n} shot không có điểm mô hình hình ảnh nên điểm được lấy từ kết quả hình ảnh (lỗi 0,85, đạt 0,10).',
      detailTitle: 'Chi tiết hợp nhất · Shot #{n}',
      close: 'Đóng',
      noImage: 'Không có ảnh',
      calcTitle: 'Tính toán',
      appliedWeight: 'Trọng số áp dụng: {type}',
      margin: 'Biên độ',
      decisionCaseLabel: 'Trường hợp',
      finalType: 'Loại lỗi cuối',
      shotTime: 'Thời điểm shot',
      mold: 'Khuôn',
      scoreSource: 'Nguồn điểm hình ảnh',
      source: {
        model: 'Xác suất mô hình hình ảnh',
        verdict: 'Suy ra từ kết quả hình ảnh',
      },
      weightVersion: 'Phiên bản trọng số',
      types: {
        FLASH: 'Bavia',
        WELDLINE: 'Đường hàn',
        SHORT: 'Thiếu nhựa',
        SINK: 'Lõm co',
        PROCESS: 'Do quy trình',
        DEFAULT: 'Mặc định (chưa rõ loại)',
      },
      prev: 'Trước',
      next: 'Sau',
    },
    shotJudge: {
      injectionInfo: 'Thông tin ép',
      drawingCaption: 'Bản vẽ sản phẩm · {id}',
      noImage: 'Không có ảnh bản vẽ',
      productNumber: 'Mã sản phẩm',
      productName: 'Tên sản phẩm',
      settingsTitle: 'Giá trị cài đặt',
      settingsBadge: 'Chuẩn so sánh · chỉ đọc',
      settingsNote: 'Giá trị cài đặt màu xanh · nguồn gốc là tab Công đoạn > Giá trị cài đặt (nguồn duy nhất)',
      settingsEstimatedNote: 'Đệm không có giá trị cài đặt nên dùng trung bình 10 shot gần nhất (ước tính)',
      estimated: 'ước tính',
      shotHistory: 'Shot History',
      recentN: '{n} shot gần nhất',
      defectOnly: 'Chỉ xem lỗi',
      colShot: 'Shot',
      colMetering: 'Định lượng',
      colInjection: 'Ép',
      colHeater: 'Gia nhiệt',
      colSpeed: 'Tốc độ',
      colCushion: 'Đệm',
      colTime: 'Thời gian',
      colJudge: 'Phán định',
      good: 'Đạt',
      bad: 'Lỗi',
      warn: 'Cảnh báo',
      none: 'Chưa phán định',
      tableNote: 'Chỉ ô vượt tiêu chuẩn tô đỏ — không tô cả hàng · nhấn hàng → cập nhật biểu đồ so sánh · tiêu chuẩn: trung bình ±3σ của các shot đã tải (ước tính)',
      loading: 'Đang tải lịch sử shot...',
      loadFailed: 'Không tải được lịch sử shot',
      empty: 'Không có shot để hiển thị',
      compareTitle: 'So sánh cài đặt vs thực đo',
      shotBadge: 'Shot #{n} · {j}',
      settingLegend: 'Cài đặt',
      measuredLegend: 'Thực đo',
      axisMetering: 'Vị trí định lượng',
      axisInjection: 'Vị trí ép',
      axisHeater: 'Nhiệt độ gia nhiệt',
      axisSpeed: 'Tốc độ ép',
      axisCushion: 'Đệm',
      axisTime: 'Thời gian ép',
      outOfSpec: 'Trục {axes} vượt tiêu chuẩn',
      inSpec: 'Tất cả các trục trong tiêu chuẩn',
      noSelection: 'Chọn một shot trong lịch sử',
      lstmButton: 'Phân tích nguyên nhân lỗi LSTM',
      measuredTitle: 'Giá trị thực đo — #{n}',
      judgeLabel: 'Phán định',
      mMetering: 'Vị trí định lượng',
      mInjection: 'Vị trí ép',
      mHeater: 'Nhiệt độ gia nhiệt',
      mSpeed: 'Tốc độ ép',
      mCushion: 'Đệm',
      mTime: 'Thời gian ép',
      lstmTitle: 'Phân tích nguyên nhân lỗi LSTM - Inline (3 mục chính)',
      lstmImportance: '1. Mức độ quan trọng của yếu tố gây lỗi',
      lstmDominant: 'Lỗi này chịu ảnh hưởng chủ yếu từ {f} ({p}%)',
      lstmRecommend: '2. Giá trị đề xuất tinh chỉnh công đoạn',
      lstmDetail: 'Xem chi tiết phân tích AI',
      colParam: 'Tham số',
      colCurrent: 'Hiện tại',
      colRecommended: 'Đề xuất',
      lstmConfidence: '3. Độ tin cậy dự đoán của mô hình',
      confidence: 'Độ tin cậy',
      confidenceNote: 'Mức có thể tin cậy phân tích này - {p}% ({lv})',
      levelHigh: 'cao',
      levelMid: 'trung bình',
      levelLow: 'thấp',
      lstmLoading: 'Đang tải kết quả phân tích LSTM...',
      lstmFailed: 'Không tải được kết quả phân tích LSTM (dịch vụ AI không phản hồi)',
      lstmNoCraft: 'Không có mã sản phẩm nên không thể chạy phân tích LSTM',
      lstmNoData: 'Không có dữ liệu phân tích',
      close: 'Đóng',
    },
    production: {
      trendTitle: 'Xu hướng sản lượng (14 ngày gần nhất)',
      avgLine: 'TB 14 ngày',
      trendNote: 'Không có mục tiêu theo máy nên dùng trung bình các ngày có sản xuất (ước tính) làm đường chuẩn · số trên cột là chênh lệch so với trung bình · sản lượng = số shot',
      sampleNote: 'API tổng hợp theo ngày chưa triển khai — gom {n} shot gần nhất theo ngày (ước tính) · đường chuẩn là trung bình các ngày có sản xuất',
      todayTitle: 'Kết quả hôm nay',
      qualityTitle: 'Đạt / Lỗi',
      production: 'Sản lượng',
      targetRatio: 'So với mục tiêu',
      pph: 'PPH',
      utilization: 'Tỷ lệ vận hành',
      goodRate: 'Tỷ lệ đạt',
      defect: 'Lỗi',
      unitShot: 'shot',
      unitShotPerHour: 'shot/h',
      estimated: 'ước tính',
      noTarget: 'Chưa thiết lập mục tiêu ngày cho máy này',
      loading: 'Đang tải dữ liệu sản xuất...',
      loadFailed: 'Không tải được dữ liệu sản xuất',
      empty: 'Không có lịch sử shot trong 14 ngày gần nhất',
      kpiNote: 'Sản lượng·tỷ lệ đạt·lỗi theo lịch sử shot hôm nay (tỷ lệ đạt tính trên shot đã phán định) · PPH là trung bình các giờ có sản xuất (ước tính) · tỷ lệ vận hành theo dòng thời gian 24h của thẻ máy · so với mục tiêu là — vì không có mục tiêu theo máy',
    },
    overviewNew: {
      realtime: 'Trạng thái vận hành',
      estimated: 'ước tính',
      estimateHint: 'Backend không có tín hiệu giai đoạn; giai đoạn được ước tính từ thời điểm shot cuối và thời gian cài đặt',
      statusRunning: 'Đang chạy',
      statusIdle: 'Chờ',
      statusStopped: 'Dừng',
      injectionShort: 'Phun',
      modelLabel: 'Mô hình vận hành máy ép: đóng khuôn, phun, giữ áp, làm mát, mở khuôn',
      modelLoading: 'Đang tải mô hình...',
      currentValues: 'Giá trị hiện tại',
      injSpeed: 'Tốc độ phun',
      injPressure: 'Áp suất phun',
      screwPosition: 'Vị trí trục vít',
      injTime: 'Thời gian phun',
      nozzleTemp: 'Nhiệt độ đầu phun',
      barrelTemp: 'Nhiệt độ xy lanh',
      cctv: 'CCTV trực tiếp',
      cctvPlaceholder: 'Camera trực tiếp',
      cctvNotConnected: 'Chưa kết nối camera',
      kpiUtilization: 'Tỷ lệ hoạt động',
      kpiShotCount: 'Số shot',
      kpiDefectRate: 'Tỷ lệ lỗi',
      kpiCycleTime: 'Thời gian chu kỳ',
      tempSummary: 'Tóm tắt nhiệt độ',
      tempLink: 'Quy trình - Tóm tắt',
      avgTemp: 'Nhiệt độ TB',
      maxDeviation: 'Độ lệch tối đa',
      warningZones: 'Zone cảnh báo',
      oilTemp: 'Nhiệt độ dầu',
      normal: 'Bình thường',
      warning: 'Cảnh báo',
      zoneUnit: '',
      recentAlarms: 'Cảnh báo gần đây',
      allAlarms: 'Tất cả',
      noAlarms: 'Không có cảnh báo gần đây',
      qualitySummary: 'Chất lượng · Sản xuất',
      qualityLink: 'Chất lượng · Sản xuất',
      goodRate: 'Tỷ lệ đạt',
      good: 'Đạt',
      defect: 'Lỗi',
      unjudged: 'Chưa đánh giá',
      cpk: 'Cpk',
      kpiDailyProduction: 'Sản lượng ngày',
      dailyProduction: 'Sản lượng ngày',
      dailyUnavailable: 'API tổng hợp hôm nay không phản hồi',
      loading: 'Đang tải dữ liệu...',
      loadFailed: 'Không thể tải dữ liệu.',
    },
    dataLog: {
      subTab: { shots: 'Nhật ký shot', drive: 'Lịch sử bộ truyền động', alarms: 'Lịch sử cảnh báo', analysis: 'Phân tích cảnh báo' },
      filter: 'Bộ lọc',
      reset: 'Đặt lại',
      unitNote: 'Đơn vị: thời gian s, vị trí và đệm mm (rê chuột lên tiêu đề cột)',
      factory: 'Nhà máy',
      machine: 'Thiết bị',
      product: 'Sản phẩm (khuôn)',
      period: 'Thời gian',
      shotRange: 'Phạm vi shot',
      columnsPick: 'Chọn cột',
      severityNotInDrive: 'Lịch sử bộ truyền động không có thông tin mức độ',
      limit: 'Số dòng',
      limitOption: '{n} dòng',
      startShot: 'Phạm vi shot (từ số)',
      startShotPlaceholder: 'Tất cả',
      sampleInterval: 'Khoảng lấy mẫu',
      intervalOption: 'Mỗi {n} shot',
      columns: 'Cột hiển thị',
      shotsTitle: 'Nhật ký shot',
      totalCount: 'Tổng {n}',
      outCount: 'Vượt {n}',
      estimated: 'ước tính',
      onlyOut: 'Chỉ vượt ngưỡng',
      no: 'STT',
      shotTime: 'Thời điểm shot',
      outNote: 'Vượt ngưỡng = ngoài trung bình ±{k}σ của các shot đã tải theo từng cột (chưa cài giới hạn, ước tính trên màn hình)',
      driveTitle: 'Lịch sử theo bộ truyền động',
      driveType: 'Bộ truyền động',
      time: 'Thời gian',
      action: 'Thao tác',
      pressure: 'Áp suất',
      speed: 'Tốc độ',
      position: 'Vị trí',
      searchPlaceholder: 'Nhập từ khóa...',
      all: 'Tất cả',
      alarmsTitle: 'Nhật ký cảnh báo',
      severity: 'Mức độ',
      critical: 'Nguy hiểm',
      warning: 'Cảnh báo',
      info: 'Thông tin',
      occurredAt: 'Thời điểm',
      code: 'Mã',
      message: 'Mô tả',
      settingValue: 'Cài đặt',
      actualValue: 'Thực tế',
      status: 'Trạng thái',
      statusActive: 'Đang xảy ra',
      statusResolved: 'Đã xử lý',
      paretoTitle: 'Phân tích Pareto cảnh báo',
      paretoNote: 'Số lần theo mã + tỷ lệ tích lũy',
      errorCode: 'Lỗi',
      timelineTitle: 'Dòng thời gian cảnh báo',
      timelineNote: 'Số lần theo khung giờ',
      baseline80: 'Mốc 80%',
      count: 'Số lần',
      cumulative: 'Tích lũy',
      loading: 'Đang tải dữ liệu...',
      loadFailed: 'Tải dữ liệu thất bại.',
      noData: 'Không có dữ liệu',
    },
    spcNew: {
      monitoring: 'Giám sát {p}',
      parameter: 'Hạng mục đo',
      loading: 'Đang tải dữ liệu SPC...',
      spcUnavailable: 'Không có cấu hình SPC cho máy và hạng mục này nên không thể tính biểu đồ kiểm soát',
      noChart: 'Không đủ shot để vẽ biểu đồ kiểm soát',
      chartNote: 'Biểu đồ trung bình nhóm con (X̄) · thời gian là shot mới nhất của mỗi nhóm con',
      rChartNote: 'Biểu đồ khoảng nhóm con (max − min) · cùng nhóm con với biểu đồ X̄',
      moldTempNoData: 'Nhiệt độ khuôn chưa được thu thập nên không thể tính biểu đồ kiểm soát',
      noData: 'không có dữ liệu',
      pp: 'PP',
      ppk: 'PPK',
      anomalyCount: '{n} gần nhất',
      outOfControl: 'Vượt',
      capabilityTitle: 'Chỉ số năng lực quy trình',
      cp: 'CP',
      cpk: 'CPK',
      defectRate: 'Tỷ lệ không phù hợp',
      subgroupSize: 'Cỡ nhóm con',
      productionTitle: 'Tóm tắt sản xuất',
      production: 'Sản lượng',
      goodRate: 'Tỷ lệ hàng tốt',
      pph: 'PPH',
      defects: 'Lỗi',
      estimated: 'ước tính',
      unitShot: 'shot',
      unitShotPerHour: 'shot/h',
      productionNote: 'Theo lịch sử shot ngày {d} · tỷ lệ hàng tốt tính trên shot đã phán định (tốt + lỗi) · PPH là trung bình các giờ có sản xuất (ước tính)',
      loadFailed: 'Tải dữ liệu thất bại.',
    },
    processNew: {
      subTab: { cycle: 'Chu kỳ', temperature: 'Nhiệt độ', drive: 'Truyền động', monitor: 'Giám sát', setup: 'Giá trị cài đặt' },
      autoScale: 'Tự động tỷ lệ',
      dataHold: 'Giữ dữ liệu',
      chart: 'Biểu đồ',
      chartAll: 'Tất cả',
      loading: 'Đang tải dữ liệu...',
      loadFailed: 'Không thể tải dữ liệu.',
      noData: 'Không có dữ liệu',
      noProfile: 'Không có dữ liệu hồ sơ',
      noTrend: 'Không có dữ liệu xu hướng',
      estimated: 'ước tính',
      step: 'Bước',
      shotNo: 'Shot',
      average: 'TB',
      overlay: 'Chồng {a}/{b}',
      singleShot: 'Shot {a}',
      injectionProfile: 'Hồ sơ phun',
      cycleTrend: 'Xu hướng thời gian chu kỳ',
      holdingProfile: 'Hồ sơ giữ áp',
      meteringProfile: 'Hồ sơ định lượng',
      cycleStats: 'Thống kê chu kỳ',
      statAvg: 'Chu kỳ TB',
      statMin: 'Nhỏ nhất',
      statMax: 'Lớn nhất',
      statStd: 'Độ lệch chuẩn',
      statLatest: 'Gần nhất',
      legendSpeed: 'Tốc độ',
      legendPressure: 'Áp suất',
      legendShot: 'SHOT',
      legendMetering: 'Định lượng',
      legendCooling: 'Làm mát',
      legendHolding: 'Giữ áp',
      legendInjection: 'Phun',
      legendCycle: 'Chu kỳ',
      legendHoldingPressure: 'Giữ áp',
      legendTime: 'Thời gian',
      legendBackPressure: 'Áp suất ngược',
      legendCushion: 'Vị trí đệm',
      legendMeteringPressure: 'Áp định lượng',
      legendInjectionPressure: 'Áp phun',
      legendUpper: 'Giới hạn trên',
      legendLower: 'Giới hạn dưới',
      statusNormal: 'Bình thường',
      statusError: 'Lỗi',
      statusRunning: 'Bình thường',
      statusIdle: 'Chờ',
      statusStopped: 'Dừng',
      setTemp: 'Cài đặt',
      deviation: 'Độ lệch',
      tempTrend: 'Xu hướng nhiệt độ',
      deviationStatus: 'Độ lệch nhiệt độ',
      deviationTolerance: 'Độ lệch theo Zone (cho phép ±{n}℃)',
      deviationFromAvg: 'Độ lệch ± so với trung bình các Zone (cho phép ±{n}℃)',
      diffFromAvg: 'So với TB',
      avgLine: 'TB {v}℃',
      tempStats: 'Thống kê nhiệt độ',
      avgTemp: 'Nhiệt độ TB',
      maxDeviation: 'Độ lệch tối đa',
      maxTemp: 'Tối đa',
      driveInjection: 'Bộ truyền động phun',
      driveMetering: 'Bộ truyền động định lượng',
      driveHolding: 'Bộ truyền động giữ áp',
      pressure: 'Áp suất',
      speed: 'Tốc độ',
      position: 'Vị trí',
      elapsed: 'Thời gian hoạt động',
      pressureTrend: 'Xu hướng áp suất',
      motorStatus: 'Trạng thái motor',
      backPressureMonitor: 'Giám sát áp suất ngược',
      axisPressureShot: 'Áp suất / Số shot',
      axisStatusShot: 'Trạng thái / Số shot',
      axisBackPressureShot: 'Áp suất ngược / Số shot',
      moldEjectorSettings: 'Cài đặt khuôn · Ejector',
      moldOpenPos: 'Vị trí mở khuôn',
      moldClosePos: 'Vị trí đóng khuôn',
      moldOpenTime: 'Thời gian mở khuôn',
      moldCloseTime: 'Thời gian đóng khuôn',
      ejectorForward: 'Ejector tiến',
      ejectorBackward: 'Ejector lùi',
      watchAutoWatch: 'Giám sát tự động',
      watchUse: 'Bật',
      watchNotUse: 'Tắt',
      watchReference: 'Giá trị tham chiếu',
      watchRefAuto: 'Lấy mẫu tự động',
      watchRefUser: 'Người dùng cài đặt',
      watchNote: 'Tham chiếu = trung bình {n} shot gần nhất, giới hạn = ±{k}σ (ước tính)',
      watchLegendOut: 'Vượt giới hạn trên/dưới',
      watchLegendImportant: 'Mục giám sát quan trọng',
      watchTable1: 'Bảng giám sát 1 - Tham số truyền động (sec/mm)',
      watchTable2: 'Bảng giám sát 2 - Tham số phun · giữ áp',
      watchRowGroup: 'Phân loại',
      watchRowActual: 'Giá trị thực',
      watchRowDeviation: 'Độ lệch',
      watchRowReference: 'Tham chiếu',
      watchRowUpper: 'Giới hạn trên',
      watchRowLower: 'Giới hạn dưới',
      watchRowSelect: 'Chọn',
      setupCount: '{n} mục',
      setupHistoryButton: 'Xem lịch sử thay đổi',
      setupHistoryUnavailable: 'Chưa có API lịch sử thay đổi cài đặt',
      setupHistoryLess: 'Chỉ xem 20 mục gần nhất',
      setupAddWidget: 'Thêm vào widget dashboard',
      setupWidgetNoSlot: 'Dashboard không còn ô trống',
      setupHistoryTitle: 'Thay đổi cài đặt gần đây',
      setupHistoryTime: 'Thời điểm',
      setupHistoryItem: 'Hạng mục',
      setupHistoryBefore: 'Trước',
      setupHistoryAfter: 'Sau',
      setupHistoryUser: 'Người thay đổi',
      setupHistoryEmpty: 'Không có thay đổi cài đặt gần đây',
    },
  },
  equipmentBoard: {
    selectMachine: 'Chọn máy ép',
    loading: 'Đang tải...',
    update: 'Cập nhật',
    empty: 'Vui lòng chọn máy ép',
    alarmHistory: 'Lịch sử cảnh báo',
    alarmEmpty: 'Không có lịch sử cảnh báo',
    occurredPrefix: 'Phát sinh ',
    statusActive: 'Đang xảy ra',
    statusResolved: 'Đã xử lý',
    shotData: 'Dữ liệu shot',
    shotCountSuffix: '{n}',
    noData: 'Không có dữ liệu',
    panelAlarm: 'Cảnh báo',
    remainingSuffix: '+{n} khác',
    confirm: 'Xác nhận',
    confirmWithRemaining: 'Xác nhận (+{n} khác)',
    cols: {
      shotTime: 'Thời gian shot',
      craftId: 'Sản phẩm',
      shotCount: 'Số shot',
      cycleTime: 'Chu kỳ',
      injTime: 'Thời gian ép',
      holdTime: 'Thời gian giữ áp',
      chargeTime: 'Thời gian cấp liệu',
      moldOpenTime: 'Thời gian mở khuôn',
      moldCloseTime: 'Thời gian đóng khuôn',
      fetchTime: 'Thời gian lấy sản phẩm',
      ejectTime: 'Thời gian đẩy',
    },
  },
  machineDataView: {
    title: 'Tra cứu dữ liệu máy ép',
    loading: 'Đang tải...',
    loadingDataInit: 'Đang tải dữ liệu...',
    loadingProgressInit: 'Đang tải {total} máy...',
    loadingProgress: 'Đang tải {loaded}/{total} máy...',
    allMachines: 'Tất cả máy ép',
    machineCount: '{n} máy',
    allMolds: 'Tất cả khuôn',
    countSuffix: '{n}',
    total: 'Tổng {n}',
    filteredTotal: '{filtered} / {total}',
    empty: 'Không có dữ liệu',
    pageInfo: '{start}-{end} / {total}',
  },
};

export default monitoring;
